module.exports = __webpack_public_path__ + "static/media/5_tom_a.698c4c39.ogg";